import type { StyleProp, ViewStyle } from "react-native";

import { palette, spacing } from "@stepapp/ui";

export const smallPageWrapper: StyleProp<ViewStyle> = {
  backgroundColor: palette.common.white,
  minHeight: spacing.deviceHeight / 2,
  minWidth: 350,
  width: "100%",
};
